import {
  FormLabelProps,
  Select as ChakraSelect,
  SelectProps as ChakraSelectProps,
  Flex,
  FormLabel,
  FlexProps,
  InputGroup,
} from '@chakra-ui/react';
import useTranslate from '~/common/utils/translate';
import { Text } from './Text';
import React from 'react';

type SelectProps = Omit<ChakraSelectProps, 'left'> & {
  label?: string;
  labelAsText?: boolean;
  labelProps?: FormLabelProps;
  labelParams?: string[];
  placeholderParams?: string[];
  row?: boolean;
  flexProps?: FlexProps;
  left?: React.ReactNode;
};

export const Select: React.FC<SelectProps> = ({
  placeholderParams,
  children,
  placeholder,
  label,
  labelAsText = false,
  labelProps,
  labelParams,
  row,
  flexProps,
  left,
  ...props
}) => {
  const translate = useTranslate();
  return (
    <Flex
      direction={row ? 'row' : 'column'}
      align="center"
      alignItems="flex-end"
      {...flexProps}
    >
      {label ? (
        labelAsText ? (
          <Text params={labelParams}>{label}</Text>
        ) : (
          <FormLabel {...labelProps}>{translate(label, labelParams)}</FormLabel>
        )
      ) : null}
      <InputGroup>
        {left}
        <ChakraSelect
          placeholder={translate(placeholder, placeholderParams)}
          textIndent={left ? '1rem' : '0'}
          {...props}
        >
          {children}
        </ChakraSelect>
      </InputGroup>
    </Flex>
  );
};
